import { practitionerSignUp } from "@unauthenticated/shared/locales/en/US/practitionerSignUp";

import { common } from "./common";

export const US = {
  common,
  practitionerSignUp,
};
